module.exports = __webpack_public_path__ + "static/media/Add.2a62ae97.svg";